import * as l from '../../../utils/localization/format'
import { BasicSelectOption } from '../../forms/Select/interfaces'

import { AccountOption } from './interfaces'

export function groupAccountOptions(options: AccountOption[]): BasicSelectOption[] {
  const pinnedAccounts = options.filter((acc) => acc.isPinned)
  const otherAccounts = options.filter((acc) => !acc.isPinned)

  if (pinnedAccounts.length === 0 || otherAccounts.length === 0) {
    return options
  }

  const result: AccountOption[] = []

  if (pinnedAccounts.length > 0) {
    result.push({ type: 'group', label: l.translate('Pinned'), value: 'pinned', id: 'pinned' })
    result.push(...pinnedAccounts)
  }

  if (result.length > 0 && otherAccounts.length > 0) {
    result.push({ type: 'group', label: l.translate('Other'), value: 'other', id: 'other' })
  }

  result.push(...otherAccounts)

  return result
}
